import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import {
  GET_PERMSTIONS_LIST,
  SUBMIT_PROFILE,
  GET_PROFILE_DATA,
} from "./actionTypes";
import {
  GetPermstionsListSuccessful,
  getProfiledata,
  getProfiledataSuccessful,
} from "./actions";
import { apiError } from "../../CompanySettings/users/actions";

// AUTH related methods
import {
  postAdd,
  getList,
  // getParamsList,
  postEdit,
  // patchEdit,
  // postDelete,
  // getRowData,
  // postUpload,
} from "../../../helpers/Helper";
import swal from "sweetalert";

function* PermstionsList({ payload: { id } }) {
  try {
    const response = yield call(getList, "/users/contenttypes/", {});

    yield put(GetPermstionsListSuccessful(response));
    if (id !== "0") {
      yield put(getProfiledata(id));
    }
  } catch (error) {
    yield put(apiError(error));
  }
}
function* ProfileData({ payload: { id } }) {
  try {
    const response = yield call(getList, "/users/groups/" + id, {});
    yield put(getProfiledataSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* profileAdd({ payload: { data, profileID, history } }) {
  try {
    if (profileID === "0") {
      const response = yield call(postAdd, "/users/groups/", data);

      if (response.status === 201) {
        swal("Your Profile Added Successfully.!", {
          icon: "success",
        });

        history.push("/Users");
      } else {
        swal("Sorry! Unable to add Profile. Please Try Again!", {
          icon: "error",
        });
      }
    } else {
      const response = yield call(postEdit, "/users/groups/" + profileID, data);
      if (response.status === 200) {
        swal("Your Profile Edited Successfully.!", {
          icon: "success",
        });
        history.push("/Users");
      } else {
        swal("Sorry! Unable to edit Profile. Please Try Again!", {
          icon: "error",
        });
      }
    }
  } catch (error) {
    swal(error, {
      icon: "error",
    });
  }
}
export function* watchGetPermstionsList() {
  yield takeEvery(GET_PERMSTIONS_LIST, PermstionsList);
}
export function* watchProfileAdd() {
  yield takeEvery(SUBMIT_PROFILE, profileAdd);
}
export function* watchProfileData() {
  yield takeEvery(GET_PROFILE_DATA, ProfileData);
}

function* ProfileSaga() {
  yield all([
    fork(watchGetPermstionsList),
    fork(watchProfileAdd),
    fork(watchProfileData),
  ]);
}

export default ProfileSaga;
